export const getRoomPrice = (id: any, roomTypeList1: any) => {
  const room = roomTypeList1?.find((room: any) => room.id === id);

  if (room) {
    return room;
  } else {
    return 0; // You can return some default value or handle the case when the room is not found.
  }
};
